// extracted by mini-css-extract-plugin
module.exports = {"scriptBanner":"b"};